import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_BaseDatos.pre_insercion",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
				  })
			})
	},

	consulta_poliza(p_email, p_ejecutivo, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_BaseDatos.fnc_consultaPoliza",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_poliza": p_poliza,
			  })
		})
	},

	consulta_contratante(p_email, p_contratante){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_BaseDatos.fnc_consultacontratante",
			"p_args_in": JSON.stringify({
				"p_contratante": p_contratante,
				})
		})
	},
	consulta_corredor(p_email, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_BaseDatos.fnc_consultaCorredor",
			"p_args_in": JSON.stringify({
				"p_codcorredor": p_corredor,
				})
		})
	},
	consulta_contactos(p_email, p_ejecutivo, p_poliza, p_contratante, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_BaseDatos.fnc_ConsultaContactos",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_poliza": p_poliza,
				"p_contratante": p_contratante,
				"p_corredor": p_corredor,
				})
		})
	},
	eliminar(p_email, p_usuario,p_id){
        return axios
        .post('spoc/modppentry', {
            "p_email": p_email,
            "p_metodo": "pkg_compp_BaseDatos.eliminar",
            "p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_id": p_id
                })
        })
    },
	insertar(p_email, p_usuario, p_poliza, p_nombre, p_apellido, 
		p_cargo , p_mail, p_telefono, p_movil, 
		p_pais, p_ciudad, p_comuna, p_direccion, 
		p_renovacion, p_observaciones, p_diadia){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_BaseDatos.insertar",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza,
				"p_nombre": p_nombre,
				"p_apellido": p_apellido,
				"p_cargo": p_cargo,
				"p_mail": p_mail,
				"p_telefono": p_telefono,
				"p_movil": p_movil,
				"p_pais": p_pais,
				"p_ciudad": p_ciudad,
				"p_comuna": p_comuna,
				"p_direccion": p_direccion,
				"p_renovacion": p_renovacion,
				"p_observaciones": p_observaciones,
				"p_diadia": p_diadia
				})
		})
	},
	editar(p_email, p_usuario, p_poliza, p_nombre, p_apellido, 
		p_cargo , p_mail, p_telefono, p_movil, 
		p_pais, p_ciudad, p_comuna, p_direccion, 
		p_renovacion, p_observaciones, p_id, p_diadia){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_BaseDatos.Editar",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza,
				"p_nombre": p_nombre,
				"p_apellido": p_apellido,
				"p_cargo": p_cargo,
				"p_mail": p_mail,
				"p_telefono": p_telefono,
				"p_movil": p_movil,
				"p_pais": p_pais,
				"p_ciudad": p_ciudad,
				"p_comuna": p_comuna,
				"p_direccion": p_direccion,
				"p_renovacion": p_renovacion,
				"p_observaciones": p_observaciones,
				"p_id": p_id,
				"p_diadia": p_diadia
				})
		});
	},
	recuperar(p_email, p_ejecutivo, p_poliza, p_contratante, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_BaseDatos.recuperar",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_poliza": p_poliza,
				"p_contratante": p_contratante,
				"p_corredor": p_corredor,
				})
		})
	},
}